import { RichtextBlocksTypewriter } from "/_types";
import { TypeOptions, Typography } from "/typography";
import { JSONParse } from "/utils";
import { FC, useEffect, useRef, useState } from "react";
import { render } from "react-dom";

export const initTypewriter = () => {
  document.querySelectorAll<HTMLDivElement>("[data-typewriter]").forEach((element) => {
    const settings = JSONParse<RichtextBlocksTypewriter["settings"]>(element.dataset.typewriter);
    render(<TypeWriter {...settings} />, element);
  });
};

const typeAnimation = `<span class="animate-typewriter inline-flex items-center px-0.5"><span class="w-[0.125em] h-[1em] my-auto bg-current"></span></span>`;

export const TypeWriter: FC<RichtextBlocksTypewriter["settings"]> = ({
  content: title,
  content_font: title_font,
  text_1,
  text_2,
  text_3,
  text_4,
  text_5,
  text_6,
  ...settings
}) => {
  const contentBlocks = [text_1, text_2, text_3, text_4, text_5, text_6].filter(
    (t) => !!t.replace(/^\s*$/gi, "")
  );
  const currentIndex = useRef(0);
  const currentLength = useRef(0);
  const direction = useRef(1);
  const interval = useRef<NodeJS.Timer>();
  const [content, setContent] = useState(title.replace("[content]", typeAnimation));

  useEffect(() => {
    if (!contentBlocks.length) return;
    if (
      title.replace("[content]", contentBlocks[currentIndex.current] + typeAnimation) === content
    ) {
      direction.current = -1;
      clearInterval(interval.current);
      setTimeout(() => {
        interval.current = setInterval(
          () => {
            currentLength.current += direction.current;
            setContent(
              title.replace(
                "[content]",
                contentBlocks[currentIndex.current].substring(0, currentLength.current) +
                  typeAnimation
              )
            );
          },
          130 * (1 - settings.speed / 100)
        );
      }, settings.delay * 1000);
    }
    if (title.replace("[content]", typeAnimation) === content) {
      direction.current = 1;
      clearInterval(interval.current);
      currentIndex.current =
        currentIndex.current + 1 < contentBlocks.length ? currentIndex.current + 1 : 0;

      setTimeout(() => {
        interval.current = setInterval(
          () => {
            currentLength.current += direction.current;
            setContent(
              title.replace(
                "[content]",
                contentBlocks[currentIndex.current].substring(0, currentLength.current) +
                  typeAnimation
              )
            );
          },
          280 * (1 - settings.speed / 100)
        );
      }, 300);
    }
  }, [content, contentBlocks, settings.delay, settings.speed, title]);

  return (
    <div style={{ minHeight: `${settings.min_height}px` }}>
      <Typography fontType={title_font as unknown as TypeOptions}>{content}</Typography>
    </div>
  );
};
